<template>
  <div data-app="true" @click="resetTimeBeforeCloseSession()">
    <div id="app_body">
      <router-view v-if="dataReady"></router-view>

      <!-- <div v-if="pageLoaded">
      </div>
      
      <transition name="fade">
        <div v-if="!pageLoaded" id="presentation_container">
          <img src="/media/gifts/Intro.gif" alt="">
        </div>
      </transition> -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import ProductCategories from "./store/Modules/ProductCategories";
import ShoppingCar from "./store/Modules/ShoppingCar";

export default {
  name: "app",
  data: function () {
    return {
      loading: true, // page loaded default false
      sessionInterval: null,
    };
  },
  async created() {
    await this.setInitialState();
  },
  mounted() {
    let self = this;
    if (self.$route.path == "/") {
      setTimeout(function () {
        self.loading = false;
      }, 4500);
    } else {
      self.loading = false;
    }
    if (document.documentElement.clientWidth < 640) {
      // Hay componentes que se deben renderizar solo en la versión web
      this.setIsMobileView(true);
      // console.log("movil");
    } else {
      this.setIsMobileView(false);
      // console.log("Desktop");
    }
  },
  computed: {
    userToken() {
      let token = null;
      if (this.$store.state.SessionStore.user) {
        token = this.$store.state.SessionStore.user.token;
      }
      return token;
    },
    dataReady() {
      const productCategories =
        this.$store.state.BuyProcessStore.productCategories;
      const shoppingCar = this.$store.state.ShoppingCarStore.shoppingCar;
      return Boolean(
        productCategories &&
          typeof productCategories.getItems === "function" &&
          shoppingCar &&
          typeof shoppingCar.getItems === "function"
      );
    },
    currentRouteName() {
      return this.$route.name;
    },
    // appStyle() {
    //   let style = {};
    //   if (this.$store.state.bgApp) {
    //     style["backgroundImage"] =
    //       "url(" + require("/" + this.$store.state.bgApp) + ")";
    //   }
    //   return style;
    // },
    pageLoaded() {
      return !this.loading && this.dataReady;
    },
  },
  methods: {
    ...mapMutations([
      "setIsMobileView",
      "setIsUserSideBarOpen",
      "resetTimeBeforeCloseSession",
      "setProductCategories",
      "setShoppingCar",
      "decrementTimeBeforeCloseSession",
    ]),
    ...mapActions(["getProductCategories", "logout"]),
    async setInitialState() {
      this.setIsUserSideBarOpen({ status: false });
      // *Get disponible categories
      try {
        let categoriesResult = await this.getProductCategories();
        this.setProductCategories(new ProductCategories(categoriesResult || []));
      } catch (error) {
        this.setProductCategories(new ProductCategories([]));
        if (this.$notify && this.$notify.danger) {
          this.$notify.danger(
            "No hay conexión con el API. Revisa que el backend esté en http://127.0.0.1:8000"
          );
        }
      }
      // *Instance of global shoppingCar
      this.setShoppingCar(new ShoppingCar([]));
      this.setSesisionConfig();

      if (window.performance) {
        // console.info("window.performance work's fine on this browser");
      }
      if (performance.getEntriesByType("navigation")[0].type != "navigate") {
        this.logout().then(() => {
          if (this.$route.path != "/") this.$router.push("/");
        });
      } else {
        // console.info( "This page is not reloaded");
      }
    },
    setSesisionConfig() {
      this.sessionInterval = window.setInterval(() => {
        if (this.$store.state.SessionStore.timeBeforeCloseSession > 0) {
          this.decrementTimeBeforeCloseSession(1000);
        } else {
          if (this.userToken) {
            this.$store.state.ShoppingCarStore.shoppingCar.reset();
            this.logout().then(() => this.$router.push("/"));
          }
        }
      }, 1000);
    },
  },
  unmounted() {
    window.clearInterval(this.sessionInterval);
  },
};
</script>

<style scoped>
#app_body {
  /* height: 100vh !important;
    background-color: red; */
}
</style>
